import cubbit from "../../assets/cubbit.png";

export const cubbitProduct = {
  id: 1,
  name: "Cubbit Cell",
  img: cubbit,
  description: "Cubbit Cell 1TB up to 4TB",
  price: 589,
  shipping: "0",
  discount: 44,
};
